export default "__VITE_ASSET__C$31vT4O__"